import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Clock, ArrowRight } from 'lucide-react';

const newsletters = [
  {
    slug: 'anil-kumar',
    label: 'S3 · EP 01 · Chemistry',
    guest: 'Dr. Anil Kumar Kruthiventi',
    role: 'R&D Leader · Tata Chemicals · Professor of Practice, CUTM',
    headline:
      'The Molecular World: What a Chemist Taught Me About Divinity, Innovation, and the Careers Nobody Sees',
    readTime: '~18 min read',
  },
  {
    slug: 'sai-santosh',
    label: 'S3 · EP 02 · Physics',
    guest: 'Dr. Sai Santosh Kumar Raavi',
    role: 'Professor of Physics, IIT Hyderabad · Fellow, Royal Society of Chemistry',
    headline: 'He Got a BITS Seat. He Chose BSc Physics Instead.',
    readTime: '~14 min read',
  },
  {
    slug: 'rajesh-gopakumar',
    label: 'S3 · EP 03 · Theoretical Physics',
    guest: 'Prof. Rajesh Gopakumar',
    role: 'Distinguished Professor & Director, ICTS-TIFR · JEE AIR 1, 1987',
    headline: 'He Got AIR 1. He Still Got Asked Why Physics.',
    readTime: '~16 min read',
  },
];

const Newsletters = () => {
  return (
    <div className="min-h-screen pt-24 pb-20 bg-dark-bg" data-testid="newsletters-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-16 pt-8">
          <p className="text-gold text-xs font-medium uppercase tracking-widest mb-4">
            Science Unlocked
          </p>
          <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-medium text-warm-white mb-6 tracking-tight leading-tight">
            Read the Series
          </h1>
          <p className="text-lg text-warm-white/60 max-w-2xl leading-relaxed">
            Long-form companion pieces to each Science Unlocked episode. One
            scientist, one story, one career path explored in full.
          </p>
        </div>

        {/* Newsletter Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {newsletters.map((nl) => (
            <Link
              key={nl.slug}
              to={`/newsletters/${nl.slug}`}
              data-testid={`newsletter-card-${nl.slug}`}
              className="block group"
            >
              <Card className="h-full border border-gold/20 bg-dark-card hover:border-gold/50 transition-all duration-300 flex flex-col">
                <CardContent className="p-8 flex flex-col flex-1">
                  <p className="text-gold text-xs font-medium uppercase tracking-[0.2em] mb-6">
                    {nl.label}
                  </p>

                  <h2 className="font-playfair text-2xl font-medium text-warm-white mb-4 leading-snug group-hover:text-gold transition-colors">
                    {nl.headline}
                  </h2>

                  <div className="mb-6">
                    <p className="text-warm-white font-medium">{nl.guest}</p>
                    <p className="text-warm-white/50 text-sm leading-relaxed">
                      {nl.role}
                    </p>
                  </div>

                  <div className="mt-auto flex items-center justify-between pt-6 border-t border-dark-border">
                    <span className="flex items-center gap-1.5 text-warm-white/50 text-xs uppercase tracking-wider">
                      <Clock className="w-3.5 h-3.5" />
                      {nl.readTime}
                    </span>
                    <span className="flex items-center gap-2 text-gold text-xs uppercase tracking-wider font-semibold">
                      Read
                      <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Newsletters;
